import React, { useState } from "react";
import { useGlobalContext } from "../Config";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Calendar } from "primereact/calendar";
import { Chart } from "primereact/chart";

const Tarifa = () => {
  const { baseUrl } = useGlobalContext();
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [tarifas, setTarifas] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [graficoHistorial, setGraficoHistorial] = useState(null);
  const [opcionesGrafico, setOpcionesGrafico] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingHistorial, setLoadingHistorial] = useState(false);
  const [tipoHistorial, setTipoHistorial] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [modoDialogo, setModoDialogo] = useState("editar");
  const [tarifaActualizada, setTarifaActualizada] = useState({
    tipo: "",
    valor: "",
    vigenteDesde: null,
  });

  const idUsuario = sessionStorage.getItem("userId");

  const empresas = [
    { label: "ALTAMIRA", value: 1 },
    { label: "LA SIEMBRA", value: 2 },
  ];

  const tiposTarifa = [
    { label: "AGUA", value: "AGUA" },
    { label: "ELECTRICIDAD", value: "ELECTRICIDAD" },
  ];

  const obtenerUnidadPorTipo = (tipo) => {
    return tipo === 1 ? "m³" : "kWh";
  };

  const obtenerDescripcionUnidadPorTipo = (tipo) => {
    return tipo === 1 ? "Metro cúbico (m³)" : "Kilowatt-hora (kWh)";
  };

  const convertirFechaAString = (fecha) => {
    if (!fecha) return "";
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    const day = String(fecha.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const parsearFechaLocal = (fechaStr) => {
    if (!fechaStr) return null;
    const partes = fechaStr.split("-");
    if (partes.length !== 3) return null;

    const year = parseInt(partes[0], 10);
    const month = parseInt(partes[1], 10) - 1;
    const day = parseInt(partes[2], 10);

    return new Date(year, month, day);
  };

  const normalizarFecha = (fecha) => {
    return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
  };

  const formatearFecha = (fechaStr) => {
    if (!fechaStr) return "-";

    const fecha = parsearFechaLocal(fechaStr);
    if (!fecha) return fechaStr;

    const day = String(fecha.getDate()).padStart(2, "0");
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    const year = fecha.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const obtenerTextoVigenteHasta = (tarifa) => {
    if (!tarifa) return "-";

    if (tarifa.vigenteHasta) {
      return formatearFecha(tarifa.vigenteHasta);
    }

    if (!tarifa.vigenteDesde) {
      return "-";
    }

    const hoy = normalizarFecha(new Date());
    const fechaInicio = parsearFechaLocal(tarifa.vigenteDesde);

    if (!fechaInicio) {
      return "-";
    }

    const fechaInicioNormalizada = normalizarFecha(fechaInicio);

    if (fechaInicioNormalizada > hoy) {
      return "AÚN NO VIGENTE";
    }

    return "VIGENTE";
  };

  const obtenerClaveMes = (fecha) => {
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const obtenerEtiquetaMes = (claveMes) => {
    const [year, month] = claveMes.split("-");
    const fecha = new Date(parseInt(year, 10), parseInt(month, 10) - 1, 1);

    const nombreMes = fecha.toLocaleDateString("es-CL", {
      month: "short",
      year: "2-digit",
    });

    return nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1);
  };

  const construirGraficoHistorial = (tarifasHistorial, tipo) => {
    if (!tarifasHistorial || tarifasHistorial.length === 0) {
      setGraficoHistorial(null);
      setOpcionesGrafico(null);
      return;
    }

    const unidad = obtenerUnidadPorTipo(tipo);

    const registrosValidos = tarifasHistorial
      .filter(
        (item) =>
          item.vigenteDesde &&
          item.tarifa !== null &&
          item.tarifa !== undefined,
      )
      .map((item) => {
        const fecha = parsearFechaLocal(item.vigenteDesde);
        return {
          ...item,
          fechaObj: fecha,
          tarifaNumero: Number(item.tarifa),
        };
      })
      .filter(
        (item) =>
          item.fechaObj instanceof Date && !isNaN(item.fechaObj.getTime()),
      )
      .sort((a, b) => a.fechaObj - b.fechaObj);

    if (registrosValidos.length === 0) {
      setGraficoHistorial(null);
      setOpcionesGrafico(null);
      return;
    }

    const ultimoRegistro =
      registrosValidos[registrosValidos.length - 1].fechaObj;
    const meses = [];

    for (let i = 11; i >= 0; i--) {
      const fecha = new Date(
        ultimoRegistro.getFullYear(),
        ultimoRegistro.getMonth() - i,
        1,
      );
      meses.push(obtenerClaveMes(fecha));
    }

    const ultimoRegistroPorMes = {};

    registrosValidos.forEach((item) => {
      const claveMes = obtenerClaveMes(item.fechaObj);

      if (meses.includes(claveMes)) {
        if (
          !ultimoRegistroPorMes[claveMes] ||
          item.fechaObj > ultimoRegistroPorMes[claveMes].fechaObj
        ) {
          ultimoRegistroPorMes[claveMes] = item;
        }
      }
    });

    const labels = meses.map((mes) => obtenerEtiquetaMes(mes));
    const data = meses.map((mes) =>
      ultimoRegistroPorMes[mes] ? ultimoRegistroPorMes[mes].tarifaNumero : null,
    );

    setGraficoHistorial({
      labels,
      datasets: [
        {
          label: `Tarifa (${unidad})`,
          data,
          tension: 0.3,
          fill: false,
        },
      ],
    });

    setOpcionesGrafico({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              const valor = context.raw;
              if (valor === null || valor === undefined) {
                return "Sin registro";
              }
              return `Tarifa: $${valor} / ${unidad}`;
            },
          },
        },
      },
      scales: {
        x: {
          ticks: {
            autoSkip: false,
          },
        },
        y: {
          beginAtZero: false,
          ticks: {
            callback: function (value) {
              return `$${value} / ${unidad}`;
            },
          },
        },
      },
    });
  };

  const abrirDialogoEdicion = (tipo) => {
    setModoDialogo("editar");
    setTarifaActualizada({
      tipo,
      valor: "",
      vigenteDesde: null,
    });
    setShowDialog(true);
  };

  const abrirDialogoCreacionConTipo = (tipo) => {
    setModoDialogo("crear");
    setTarifaActualizada({
      tipo,
      valor: "",
      vigenteDesde: null,
    });
    setShowDialog(true);
  };

  const buscarTarifas = async () => {
    if (!empresaSeleccionada) {
      alert("Por favor selecciona una empresa.");
      return;
    }

    setIsLoading(true);
    const endpoint = `${baseUrl}buscarTarifasActivasPorEmpresa?idEmpresa=${empresaSeleccionada}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        credentials: "include",
        redirect: "follow",
      });

      const data = await response.json();

      if (!response.ok || !data.respuesta) {
        const mensaje = data?.mensaje || "Error al buscar tarifas.";

        if (mensaje.includes("NO EXISTEN TARIFAS") || response.status === 404) {
          setTarifas([]);
          setHistorial([]);
          setGraficoHistorial(null);
          setOpcionesGrafico(null);
          return;
        }

        throw new Error(mensaje);
      }

      const tarifasTraducidas = data.tarifas.map((tarifa) => ({
        ...tarifa,
        tipoDescripcion: tarifa.idTipo === 1 ? "AGUA" : "ELECTRICIDAD",
        unidadTarifa: obtenerUnidadPorTipo(tarifa.idTipo),
        unidadDescripcion: obtenerDescripcionUnidadPorTipo(tarifa.idTipo),
      }));

      tarifasTraducidas.sort((a, b) => a.idTipo - b.idTipo);

      setTarifas(tarifasTraducidas);
      setHistorial([]);
      setGraficoHistorial(null);
      setOpcionesGrafico(null);
    } catch (error) {
      alert("Error al buscar tarifas: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const verHistorial = async (tipo) => {
    if (!empresaSeleccionada) {
      alert("Por favor selecciona una empresa.");
      return;
    }

    setLoadingHistorial(true);

    const nombreHistorial = tipo === 1 ? "Agua" : "Electricidad";
    setTipoHistorial(nombreHistorial);

    const endpoint = `${baseUrl}buscarTarifasPorTipoOEmpresa?idEmpresa=${empresaSeleccionada}&idTipo=${tipo}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        credentials: "include",
        redirect: "follow",
      });

      const data = await response.json();

      if (!response.ok || !data.respuesta) {
        throw new Error(data.mensaje || "Error al buscar el historial.");
      }

      const tarifasHistorial = data.tarifas || [];
      setHistorial(tarifasHistorial);
      construirGraficoHistorial(tarifasHistorial, tipo);
    } catch (error) {
      setHistorial([]);
      setGraficoHistorial(null);
      setOpcionesGrafico(null);
      alert("Error al buscar el historial: " + error.message);
    } finally {
      setLoadingHistorial(false);
    }
  };

  const guardarTarifa = async () => {
    const valorNumerico = parseFloat(tarifaActualizada.valor);

    if (!tarifaActualizada.tipo) {
      alert("Por favor selecciona el tipo de tarifa.");
      return;
    }

    if (!valorNumerico || isNaN(valorNumerico) || valorNumerico <= 0) {
      alert("Por favor ingresa un valor mayor a 0.");
      return;
    }

    if (!tarifaActualizada.vigenteDesde) {
      alert("Por favor selecciona la fecha de vigencia desde.");
      return;
    }

    if (!empresaSeleccionada) {
      alert("Debe seleccionar una empresa.");
      return;
    }

    const idTipo = tarifaActualizada.tipo === "AGUA" ? 1 : 2;
    const vigenteDesde = convertirFechaAString(tarifaActualizada.vigenteDesde);

    try {
      const response = await fetch(
        `${baseUrl}insertarTarifa?idTipo=${idTipo}&idEmpresa=${empresaSeleccionada}&tarifa=${valorNumerico}&idUsuario=${idUsuario}&vigenteDesde=${vigenteDesde}`,
        {
          method: "POST",
          credentials: "include",
          redirect: "follow",
        },
      );

      const data = await response.json();

      if (!response.ok || !data.respuesta) {
        throw new Error(data.mensaje || "Error al guardar la tarifa.");
      }

      alert(
        modoDialogo === "crear"
          ? "Tarifa creada con éxito."
          : "Tarifa actualizada con éxito.",
      );

      setShowDialog(false);
      setTarifaActualizada({
        tipo: "",
        valor: "",
        vigenteDesde: null,
      });

      buscarTarifas();
      setHistorial([]);
      setGraficoHistorial(null);
      setOpcionesGrafico(null);
    } catch (error) {
      console.error("Error al guardar tarifa:", error);
      alert("Ocurrió un error al guardar la tarifa: " + error.message);
    }
  };

  const vigenteDesdeBody = (rowData) => {
    return formatearFecha(rowData.vigenteDesde);
  };

  const vigenteHastaBody = (rowData) => {
    return obtenerTextoVigenteHasta(rowData);
  };

  const obtenerTarifaPorTipo = (idTipo) => {
    if (!tarifas || !Array.isArray(tarifas)) return null;
    return tarifas.find((tarifa) => tarifa.idTipo === idTipo) || null;
  };

  return (
    <div className="col-12 md:col-12">
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h4 style={{ margin: 0, color: "#495057" }}>Gestión de Tarifas</h4>
        </div>

        <div
          style={{
            padding: "20px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
          }}
        >
          <h5
            style={{
              borderBottom: "2px solid #ced4da",
              paddingBottom: "10px",
              marginBottom: "20px",
              color: "#495057",
            }}
          >
            Seleccione parámetros:
          </h5>

          <div className="grid" style={{ marginBottom: "20px" }}>
            <div className="col-12" style={{ paddingRight: "10px" }}>
              <label htmlFor="empresa" style={{ fontWeight: "bold" }}>
                Empresa:
              </label>
              <Dropdown
                id="empresa"
                value={empresaSeleccionada}
                options={empresas}
                onChange={(e) => {
                  setEmpresaSeleccionada(e.value);
                  setTarifas(null);
                  setHistorial([]);
                  setGraficoHistorial(null);
                  setOpcionesGrafico(null);
                }}
                placeholder="Seleccione una empresa"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ced4da",
                  marginBottom: "15px",
                }}
              />
            </div>
          </div>

          <Button
            label="Buscar"
            icon="pi pi-search"
            onClick={buscarTarifas}
            style={{
              backgroundColor: "#007bff",
              borderColor: "#007bff",
              color: "#fff",
              padding: "10px 20px",
              fontSize: "14px",
              borderRadius: "4px",
              display: "block",
              margin: "auto",
            }}
          />
        </div>
      </div>

      {isLoading && (
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <ProgressSpinner />
        </div>
      )}

      {tarifas !== null && (
        <div
          style={{
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
            marginBottom: "20px",
          }}
        >
          <h5
            style={{
              borderBottom: "2px solid #ced4da",
              paddingBottom: "10px",
              marginBottom: "20px",
              color: "#495057",
            }}
          >
            Tarifas Vigentes:
          </h5>

          <div className="grid">
            {[1, 2].map((idTipo) => {
              const tarifa = obtenerTarifaPorTipo(idTipo);
              const tipoDescripcion = idTipo === 1 ? "AGUA" : "ELECTRICIDAD";
              const unidadTarifa = obtenerUnidadPorTipo(idTipo);
              const unidadDescripcion = obtenerDescripcionUnidadPorTipo(idTipo);

              return (
                <div className="col-12 md:col-6" key={idTipo}>
                  <Card
                    title={`Tarifa ${tipoDescripcion}`}
                    style={{ marginBottom: "20px", minHeight: "260px" }}
                  >
                    {tarifa ? (
                      <>
                        <p>
                          <strong>Valor:</strong> ${tarifa.tarifa} /{" "}
                          {unidadTarifa}
                        </p>
                        <p>
                          <strong>Unidad de medida:</strong> {unidadDescripcion}
                        </p>
                        <p>
                          <strong>Modificado por:</strong>{" "}
                          {tarifa.nombreUsuario || "-"}
                        </p>
                        <p>
                          <strong>Vigente desde:</strong>{" "}
                          {formatearFecha(tarifa.vigenteDesde)}
                        </p>
                        <p>
                          <strong>Vigente hasta:</strong>{" "}
                          {obtenerTextoVigenteHasta(tarifa)}
                        </p>
                        <Button
                          label="Actualizar"
                          onClick={() => abrirDialogoEdicion(tipoDescripcion)}
                          style={{ backgroundColor: "#ffc107", color: "#fff" }}
                        />
                      </>
                    ) : (
                      <>
                        <p>
                          <strong>Estado:</strong> No existe una tarifa vigente
                          para este tipo.
                        </p>
                        <p>
                          <strong>Unidad de medida:</strong> {unidadDescripcion}
                        </p>
                        <div style={{ marginTop: "20px" }}>
                          <Button
                            label="Agregar Tarifa"
                            icon="pi pi-plus"
                            onClick={() =>
                              abrirDialogoCreacionConTipo(tipoDescripcion)
                            }
                            style={{
                              backgroundColor: "#28a745",
                              color: "#fff",
                            }}
                          />
                        </div>
                      </>
                    )}
                  </Card>
                </div>
              );
            })}
          </div>

          <div className="grid" style={{ marginTop: "20px" }}>
            <div className="col-6" style={{ textAlign: "center" }}>
              <Button
                label="Ver Historial Agua"
                className="p-button-outlined"
                onClick={() => verHistorial(1)}
                style={{
                  backgroundColor: "#17a2b8",
                  color: "#fff",
                  padding: "10px 20px",
                  fontSize: "14px",
                  borderRadius: "4px",
                }}
              />
            </div>
            <div className="col-6" style={{ textAlign: "center" }}>
              <Button
                label="Ver Historial Electricidad"
                className="p-button-outlined"
                onClick={() => verHistorial(2)}
                style={{
                  backgroundColor: "#17a2b8",
                  color: "#fff",
                  padding: "10px 20px",
                  fontSize: "14px",
                  borderRadius: "4px",
                }}
              />
            </div>
          </div>
        </div>
      )}

      {loadingHistorial && (
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <ProgressSpinner />
        </div>
      )}

      {historial.length > 0 && (
        <div
          style={{
            padding: "20px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.05)",
            marginBottom: "20px",
          }}
        >
          <h5
            style={{
              borderBottom: "2px solid #ced4da",
              paddingBottom: "10px",
              marginBottom: "20px",
              color: "#495057",
            }}
          >
            Historial de Tarifas - {tipoHistorial}
          </h5>

          {graficoHistorial && (
            <div style={{ marginBottom: "30px" }}>
              <h6
                style={{
                  marginBottom: "15px",
                  color: "#495057",
                }}
              >
                Variación de tarifa en los últimos 12 meses
              </h6>
              <div style={{ height: "300px" }}>
                <Chart
                  type="line"
                  data={graficoHistorial}
                  options={opcionesGrafico}
                />
              </div>
            </div>
          )}

          <DataTable
            value={historial}
            responsiveLayout="scroll"
            className="p-datatable-sm"
          >
            <Column field="tarifa" header="Valor" style={{ width: "25%" }} />
            <Column
              field="vigenteDesde"
              header="Vigente Desde"
              body={vigenteDesdeBody}
              style={{ width: "25%" }}
              sortable
            />
            <Column
              field="vigenteHasta"
              header="Vigente Hasta"
              body={vigenteHastaBody}
              style={{ width: "25%" }}
              sortable
            />
            <Column
              field="nombreUsuario"
              header="Usuario Modificador"
              style={{ width: "25%" }}
            />
          </DataTable>
        </div>
      )}

      <Dialog
        header={
          modoDialogo === "crear"
            ? "Agregar Nueva Tarifa"
            : `Actualizar Tarifa - ${tarifaActualizada.tipo}`
        }
        visible={showDialog}
        style={{ width: "80vw" }}
        onHide={() => setShowDialog(false)}
        footer={
          <div>
            <Button
              label="Cancelar"
              onClick={() => setShowDialog(false)}
              style={{ backgroundColor: "#dc3545", color: "#fff" }}
            />
            <Button
              label={modoDialogo === "crear" ? "Crear" : "Actualizar"}
              onClick={guardarTarifa}
              style={{ backgroundColor: "#28a745", color: "#fff" }}
            />
          </div>
        }
      >
        {modoDialogo === "crear" && (
          <div style={{ marginBottom: "20px" }}>
            <label htmlFor="tipoTarifa" style={{ fontWeight: "bold" }}>
              Tipo:
            </label>
            <Dropdown
              id="tipoTarifa"
              value={tarifaActualizada.tipo}
              options={tiposTarifa}
              onChange={(e) =>
                setTarifaActualizada({
                  ...tarifaActualizada,
                  tipo: e.value,
                })
              }
              placeholder="Seleccione un tipo"
              style={{ width: "100%" }}
            />
          </div>
        )}

        {modoDialogo === "editar" && (
          <div style={{ marginBottom: "20px" }}>
            <label style={{ fontWeight: "bold" }}>Tipo:</label>
            <InputText
              value={tarifaActualizada.tipo}
              disabled
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ced4da",
              }}
            />
          </div>
        )}

        <div style={{ marginBottom: "20px" }}>
          <label htmlFor="nuevaTarifa" style={{ fontWeight: "bold" }}>
            Tarifa:
          </label>
          <InputText
            id="nuevaTarifa"
            value={tarifaActualizada.valor}
            onChange={(e) =>
              setTarifaActualizada({
                ...tarifaActualizada,
                valor: e.target.value,
              })
            }
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ced4da",
            }}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label htmlFor="vigenteDesde" style={{ fontWeight: "bold" }}>
            Vigente Desde:
          </label>
          <Calendar
            id="vigenteDesde"
            value={tarifaActualizada.vigenteDesde}
            onChange={(e) =>
              setTarifaActualizada({
                ...tarifaActualizada,
                vigenteDesde: e.value,
              })
            }
            dateFormat="dd-mm-yy"
            showIcon
            style={{ width: "100%" }}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default Tarifa;
